"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.array = void 0;
var internal_1 = require("./internal");
exports.array = {
    at: internal_1.at,
    eq: internal_1.eq,
    first: internal_1.first,
    last: internal_1.last,
    max: internal_1.max,
    min: internal_1.min,
    rest: internal_1.rest,
    safeSlice: internal_1.safeSlice,
    scan: internal_1.scan,
    seq: internal_1.seq,
    skip: internal_1.skip,
    skipLast: internal_1.skipLast,
    take: internal_1.take,
    takeLast: internal_1.takeLast,
    zip: internal_1.zip
};
